module.exports = __webpack_public_path__ + "images/category_lp/bike/new/store_images/2_10ee0a9b110f8d17d7cf244d99845394.png";